import classNames from 'classnames';
import * as React from 'react';

import { VoiceboxDividerMessage } from 'bones/constants/voicebox/message';

export interface VoiceboxChatMessageDividerProps {
  message: VoiceboxDividerMessage;
}

export const VoiceboxChatMessageDivider: React.VFC<
  VoiceboxChatMessageDividerProps
> = ({ message }) => {
  return (
    <div
      className={classNames(
        'vb-voicebox-chat-divider',
        'vb-voicebox-chat-indicator'
      )}
    >
      <div className="vb-voicebox-chat-divider-line" />
      <div className="vb-voicebox-chat-divider-text">{message.text}</div>
      <div className="vb-voicebox-chat-divider-line" />
    </div>
  );
};
